import Alpine from 'alpinejs';
import { ExpressAppointmentRules } from '../../types/form';
import { iodine } from '../../helpers/validation';
import { FormFieldValidationAlpine, getFieldValidation } from '../../helpers/fieldValidation';
import { ExpressFormAlpine, getExpressSteps } from '../../helpers/expressSteps';

interface ExpressAppointmentFormAlpine extends ExpressFormAlpine {
    form: HTMLFormElement;
    thirdStepAppointment: () => void;
}

const rules: ExpressAppointmentRules = {
    firstname: ['required', 'noNumber'],
    lastname: ['required', 'noNumber'],
    address: ['required', 'leastOneLetter'],
    zip: ['required', 'zipOrCity'],
    phone: ['required', 'trybaPhone'],
    email: ['required', 'email', 'noPlusInEmail'],
};

document.addEventListener('alpine:init', () => {
    // @ts-ignore
    Alpine.data('initAppointmentForm', (form: HTMLFormElement, fromLanding = false): ExpressAppointmentFormAlpine & ExpressFormAlpine & FormFieldValidationAlpine => {
        return {
            ...getFieldValidation(rules),
            ...getExpressSteps(form, rules, fromLanding),
            ...{
                form,
                thirdStepAppointment() {
                    const phone = this.$refs.phone as HTMLInputElement;
                    const email = this.$refs.email as HTMLInputElement;
                    const validation = iodine.assert(
                        {
                            phone: phone.value,
                            email: email.value,
                        },
                        {
                            phone: rules.phone,
                            email: rules.email,
                        },
                    );
                    if (validation.valid) {
                        this.validationError = false
                    }
                    this.checkValidation(validation);
                }
            },
        };
    });
});
